class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Hover-to-open with intent delay (desktop, mouse only).
    // Click still works for keyboard / touch — Dawn's native <details>
    // toggle is preserved. We only assist by toggling `open` on mouse intent.
    this.openTimer = null;
    this.closeTimer = null;
    this.hoverMQ = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  closeOtherMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      if (menu.openTimer) {
        clearTimeout(menu.openTimer);
        menu.openTimer = null;
      }
      if (menu.mainDetailsToggle && menu.mainDetailsToggle.hasAttribute('open')) {
        menu.close();
      }
    });
  }

  onMouseEnter() {
    if (!this.hoverMQ.matches) return;
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.openTimer = setTimeout(() => {
      this.closeOtherMenus();
      this.mainDetailsToggle.setAttribute('open', '');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      this.openTimer = null;
    }, 100);
  }

  onMouseLeave() {
    if (!this.hoverMQ.matches) return;
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    this.closeTimer = setTimeout(() => {
      this.close();
      this.closeTimer = null;
    }, 240);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Reject browser-initiated opens. Chrome's Find-in-Page auto-opens
    // closed <details> when matching text is inside, which silently pops
    // the mega menu when a user searches the page for words that also
    // appear in the menu (e.g. "Isolation Bubble" on the About page).
    // Real user opens always have :hover or :focus-within on this element
    // at the moment the toggle fires — click sets :hover, keyboard Enter
    // on summary sets :focus-within, our hover handler also keeps :hover
    // true. Browser-initiated opens have neither, so close back.
    if (this.mainDetailsToggle.open) {
      const hovered = this.matches(':hover');
      const focused = this.matches(':focus-within');
      if (!hovered && !focused) {
        requestAnimationFrame(() => {
          if (!this.matches(':hover') && !this.matches(':focus-within')) {
            this.close();
          }
        });
        return;
      }
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
